import defaultState from "./state";

const ConfirmacionSolicitudesReducer = (state = defaultState, action) => {
  switch (action.type) {
    case "LOADING_CONFIRMACION_SOLICITUDES": {
      return Object.assign({}, state, {
        isLoading: action.isLoading,
      });
    }
    case "SET_SOLICITUDES_CONFIRMAR": {
      return Object.assign({}, state, {
        listaSolicitudes: action.listaSolicitudes,
        totalSolicitudes: action.total,
        filtrosSolicitudes: action.filtros,
      });
    }
    case "SET_SELECTED_WORKERS": {
      return Object.assign({}, state, {
        selectedWorkers: action.list,
      });
    }
    case "SET_SOLICITUDES_EMPRESA_FILTRADA_CONFIRMAR": {
      let array = [...action.listaSolicitudesFiltrada];
      return Object.assign({}, state, {
        listaSolicitudesFiltrada: array,
      });
    }

    case "SET_SOLICITUDES_EMPRESA_FILTRADA_TOTAL_CONFIRMAR": {
      return Object.assign({}, state, {
        totalSolicitudes: action.total,
      });
    }

    case "SET_SOLICITUDES_EMPRESA_FILTRADA_FILTROS_CONFIRMAR": {
      return Object.assign({}, state, {
        filtrosSolicitudes: action.filtros,
      });
    }

    case "CHANGE_TABS_INDEX_GESTIONAR": {

      let modalGestionar = state.modalGestionar;
      modalGestionar.contentId = action.newContentId;
      modalGestionar.tabPosition = action.tabPosition;
      modalGestionar.subTabContent = false;

      return Object.assign({}, state, {
        modalGestionar,
      });
    }
    case "CLICK_BTN_GESTIONAR": {
      let modalGestionar = state.modalGestionar;
      modalGestionar.subTabContent = action.subTabContent;

      return Object.assign({}, state, {
        modalGestionar,
      });
    }
    case "OPEN_CLOSE_MODAL_BORRADOR_CONFIRMAR": {
      return Object.assign({}, state, {
        isOpenModalBorrador: action.isOpen,
      });
    }
    case "OPEN_CLOSE_MODAL_GESTIONAR": {
      return Object.assign({}, state, {
        openModalGestionarSolicitud: action.isOpen,
      });
    }

    case "OPEN_CLOSE_MODAL_REJECT_GESTIONAR": {
      return Object.assign({}, state, {
        openModalRejectGestionarSolicitud: action.isOpen
      })
    }

    case "SET_DATA_SELECTED_CONFIRM": {
      return Object.assign({}, state,{
        dataSelected: action.data
      })
    }

    case "SET_DATA_SELECTED_SHOW_CONFIRM": {
      return Object.assign({}, state,{
        dataSelectedShow: action.data
      })
    }

    case "OPEN_CLOSE_MODAL_CONTINUE_CONFIRMAR": {
      return Object.assign({}, state, {
        isOpenModalContinue: action.isOpen,
      });
    }
    case "OPEN_CLOSE_MODAL_DELETE_CONFIRMAR": {
      return Object.assign({}, state, {
        isOpenModalDelete: action.isOpen,
      });
    }
    case "SET_SHOWHIDE_FORM_CONFIRMAR": {
      const actualState = { ...state };
      if (!action.showHideForm) actualState.activeStep = 1;
      return Object.assign({}, state, {
        showHideForm: action.showHideForm,
        activeStep: actualState.activeStep,
      });
    }
    case "SET_STEP_CONFIRMAR": {
      let maxStep = state.lastCompletedStep;
      if (action.step > state.lastCompletedStep) maxStep = action.step;
      return Object.assign({}, state, {
        activeStep: action.step,
        lastCompletedStep: maxStep,
      });
    }
    case "NEXT_STEP_CONFIRMAR": {
      const nextStep = state.activeStep + 1;
      return Object.assign({}, state, {
        activeStep: nextStep,
        lastCompletedStep: nextStep > state.lastCompletedStep ? nextStep : state.lastCompletedStep,
      });
    }
    case "LAST_STEP_CONFIRMAR": {
      return Object.assign({}, state, {
        activeStep: state.activeStep - 1,
      });
    }
    case "SET_DATA_NEW_COMPLAIN_CONFIRMAR": {
      return Object.assign({}, state, {
        jsonData: action.jsonData,
        isModified: true,
      });
    }
    case "SET_DRAFT_CONFIRMAR": {
      return Object.assign({}, state, {
        jsonData: action.jsonData,
        lastCompletedStep: action.jsonData.lastCompletedStep,
      });
    }
    case "EDITING_DRAFT_CONFIRMAR": {
      return Object.assign({}, state, {
        editingDraft: action.editing,
      });
    }
    case "SET_TIPO_SOLICITUD_CONFIRMAR": {
      return Object.assign({}, state, {
        selectedTipoSolicitud: action.tipo,
      });
    }
    case "SET_DATA_TRABAJADOR_CONFIRMAR": {
      return Object.assign({}, state, {
        dataTrabajador: action.data,
      });
    }
    case "UPDATE_DATA_GRID_SOLICITUDES_CONFIRMAR": {
      return Object.assign({}, state, {
        shouldUpdateDataGrid: action.update,
      });
    }
    case "SET_PENDING_COMPLAINTS_CONFIRMAR": {
      return Object.assign({}, state, {
        pendingComplaints: action.complaints,
      });
    }
    case "DISABLE_NEW_COMPLAINT_BUTTON_CONFIRMAR": {
      return Object.assign({}, state, {
        disableContinueNewComplaint: action.disable,
      });
    }
    case "SET_CLEAN_SOLICITUD_CONFIRMAR": {
      return Object.assign({}, state, {
        shouldUpdateDataGrid: false,
        listaSolicitudes: [],
        listaSolicitudesFiltrada: [],
        showHideForm: false,
        isOpenModalBorrador: false,
        isOpenModalContinue: false,
        isOpenModalDelete: false,
        isOpenModalGestionar: false,
        editingDraft: false,
        filtrosSolicitudes: null,
        totalSolicitudes: null,
        selectedTipoSolicitud: {
          Icon: "4", name: "Pendientes de aprobación", column: "estadoSolicitud", value: { text: "ingresado", value: 1 },
        },
        activeStep: 1,
        lastCompletedStep: 1,
        steps: [
          {
            id: 1,
            text: "Información de la solicitud",
            subtext: "Ingresa los datos requeridos para crear una nueva solicitud",
          },
          {
            id: 2,
            text: "Información del trabajador",
            subtext:
              "Debes llenar toda la información del trabajador que se ha accidentado",
          },
          {
            id: 3,
            text: "Datos del accidente",
            text2: "Datos de la enfermedad",
            subtext: "Describa de la forma más detallada los hechos que ocurrieron",
          },
          {
            id: 4,
            text: "Solicitante",
            subtext:
              "Información de la persona que realiza la solicitud de agenda SEL",
          },
          {
            id: 5,
            text: "Datos de la empresa",
            subtext:
              "Información de la empresa que realiza la solicitud de agenda SEL",
          },
          {
            id: 6,
            text: "Enviar denuncia",
            subtext: null,
          },
        ],
        isModified: false,
        dataTrabajador: {},
        disableContinueNewComplaint: false,
        pendingComplaints: [],
        jsonData: {
          Id: null,
          formInfoDenuncia: {},
          formInfoTrabajador: {},
          formDatoSiniestro: {},
          formDatosEmpresa: {},
          formDenunciante: {},
          formDatosEnfermedad: {},
          currentStep: 1,
        },
        modalGestionar: {
          contentId: null,
          tabPosition: 0,
          tabs: [" Información general", "Baterías/Prestaciones", "Trabajadores"],
          subTabContent: false,
          id: null,
        },
        dataSelected: null,
        dataSelectedShow: null,
        selectedWorkers: null,
        openModalGestionarSolicitud: false,
        openModalRejectGestionarSolicitud: false,
        isOpenModalEliminarTrabajador: false,
        worker: {},
      });
    }
    case "OPEN_CLOSE_MODAL_ELIMINAR_TRABAJADOR": {
      return Object.assign({}, state, {
        isOpenModalEliminarTrabajador: action.isOpen,
        worker: action.worker,
      });
    }
    
    case "SET_CLEAN_DATA_COMPLAIN": {
      return Object.assign({}, state, {
        isModified: false,
        isOpenModalBorrador: false,
        lastCompletedStep: 1,
        activeStep: 0,
        editingDraft: false,
        dataTrabajador: {},
        pendingComplaints: [],
        jsonData: {
          formInfoSolicitud: {},
          formInfoTrabajador: {},
          formDatoSiniestro: {},
          formDatosEmpresa: {},
          formSolicitante: {},
          formDatosEnfermedad: {},
        },
      });
    }

    default:
      return state;
  }
};

export default ConfirmacionSolicitudesReducer;
